var exports = {
  "uW": "VoiceActivitySection.module__section___RUtTV1",
  "eV": "VoiceActivitySection.module__moreCallsText___RUtTV1",
  "ti": "VoiceActivitySection.module__allCallsGrid___RUtTV1",
  "ux": "VoiceActivitySection.module__gridItem___RUtTV1",
};

module.exports = exports;
